import { configureStore } from '@reduxjs/toolkit';
import devicesReducer from './slices/devicesSlice';
import familyMembersReducer from './slices/familyMembersSlice';
import uiReducer from './slices/uiSlice';
import statsReducer from './slices/statsSlice';

export const store = configureStore({
  reducer: {
    devices: devicesReducer,
    familyMembers: familyMembersReducer,
    ui: uiReducer,
    stats: statsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
